import { loginActionTypes } from './login.constants';

export function loginReducer(state = {}, action) {
    switch (action.type) {
        case loginActionTypes.GET_MEMBER_REQUEST:
            return {
                ...state,
                loggingIn: true,
            };
        case loginActionTypes.GET_MEMBER_SUCCESS:
            return {
                loggingIn: false,
            };
        case loginActionTypes.GET_MEMBER_FAILURE:
            return {
                ...state,
            };
        case loginActionTypes.RESET:
            return { ...state, error: null, resetPasswordAsked: false };
        case loginActionTypes.RESET_PASSWORD_FAILURE:
            return { requestResetError: action.error };
        case loginActionTypes.USER_FOUND:
            return { ...state, candidateUser: action.user };
        case loginActionTypes.AGREEMENTS_FETCHED:
            return {
                ...state,
                loggingIn: false,
                agreements: action.agreements.agreementMap,
                agreementsAccepted: false,
            };
        case loginActionTypes.TOGGLE_AGREEMENTS:
            return { ...state, agreements: state.agreements, agreementsAccepted: action.status };
        case 'SERVER_FIVE_HUNDRED':
            return {
                ...state,
                loggingIn: false,
            };
        default:
            return state;
    }
}
